import React, { useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Line } from 'react-chartjs-2';
import { DataContext } from '../contexts/DataContext';
import 'chartjs-adapter-moment'; // Import the adapter
import moment from 'moment';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    TimeScale, // Import TimeScale
    TimeSeriesScale, // Import TimeSeriesScale
  } from 'chart.js';
  
  // Register the TimeScale and TimeSeriesScale
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
    TimeScale,
    TimeSeriesScale
  );

const ShipmentTimeSeriesChart = () => {
    const { shipments, isLoading } = useContext(DataContext);
    
    // Initialize state outside useEffect
    const [timeSeriesData, setTimeSeriesData] = useState({
        labels: [],
        datasets: [{
            label: 'Shipments',
            data: [],
            fill: false,
            backgroundColor: 'rgb(59, 130, 246)',
            borderColor: 'rgba(29, 78, 216, 0.7)',
        }],
    });

    useEffect(() => {
        if (!isLoading && shipments) {
          // Filter shipments for the years 2023 and 2024
          const filteredShipments = shipments.filter(shipment => {
            const year = moment(shipment.originEtd).year();
            return year === 2023 || year === 2024;
          });
      
          // Group shipments by month and year
          const groupByMonthYear = filteredShipments.reduce((acc, shipment) => {
            const monthYear = moment(shipment.originEtd).format('MMM YYYY');
            if (!acc[monthYear]) {
              acc[monthYear] = 0;
            }
            acc[monthYear] += 1;
            return acc;
          }, {});
      
          // Sort the months and prepare the datasets
          const sortedMonths = Object.keys(groupByMonthYear).sort((a, b) => moment(a, 'MMM YYYY').diff(moment(b, 'MMM YYYY')));
          const counts = sortedMonths.map(month => groupByMonthYear[month]);
      
          setTimeSeriesData(prevData => ({
            ...prevData,
            labels: sortedMonths,
            datasets: [{
              ...prevData.datasets[0],
              data: counts,
            }],
          }));
        }
      }, [shipments, isLoading]);
      

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
        },
        scales: {
            x: {
                type: 'time',
                time: {
                    unit: 'month'
                }
            }
        }
    };

    return (
        <div className="bg-white shadow rounded-lg p-4 w-full max-w-lg h-custom-card-big flex flex-col justify-between">
            <div className="mb-4">
                <h2 className="text-lg font-bold text-gray-800 flex items-center">
                    <FontAwesomeIcon icon={faChartLine} className="text-blue-600 mr-2" />
                    Monthly Shipments Overview
                </h2>
            </div>
            <div className="flex-grow relative">
                {isLoading ? (
                    <div className="flex justify-center items-center h-full">
                        <FontAwesomeIcon icon={faSpinner} className="animate-spin text-xl" />
                        <span className="ml-2 text-lg">Loading...</span>
                    </div>
                ) : (
                    <Line data={timeSeriesData} options={options} />
                )}
            </div>
        </div>
    );
};

export default ShipmentTimeSeriesChart;
